import {Component, OnInit, signal} from '@angular/core';
import {LibraryService} from '../services/library/library.service';
import {MatDialog} from '@angular/material/dialog';
import {Library} from '../classes/library.class';
import {Platform} from '@angular/cdk/platform';
import {LocalStorage} from '../storage.class';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {CordovaService} from '../cordova.service';
import {Router, RouterLink} from '@angular/router';
import {CodaltComponent} from '../codalt.component';
import {FirebaseX} from '@awesome-cordova-plugins/firebase-x/ngx';
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";
import {MatTooltip} from "@angular/material/tooltip";
import {MatRipple} from "@angular/material/core";
import {LibraryTreeComponent} from "./library-tree/library-tree.component";
import {MatButton} from "@angular/material/button";

declare var cordova;

@Component({
    selector: 'app-library',
    templateUrl: './library.component.html',
    styleUrls: ['./library.component.scss'],
    imports: [
        VvrIconComponent,
        MatSlideToggle,
        FormsModule,
        RouterLink,
        MatTooltip,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        MatRipple,
        LibraryTreeComponent,
        MatButton
    ]
})
export class LibraryComponent extends CodaltComponent implements OnInit {

    readonly isRead = signal<boolean>(false);
    readonly editMode = signal<boolean>(false);
    readonly touchDevice = signal<boolean>(false);

    readonly libraryChapters = signal<Library[]>([]);
    readonly selectedChapter = signal<Library[]>(null);

    constructor(
        public platform: Platform,
        private confirmDialogService: ConfirmDialogService,
        private libraryService: LibraryService,
        private dialog: MatDialog,
        private router: Router,
        private firebase: FirebaseX,
        private cordovaService: CordovaService
    ) {
        super();
    }

    ngOnInit() {
        this.touchDevice.set(this.platform.ANDROID || this.platform.IOS);
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        this.isRead.set(!this.AuthorisationService.hasAnyFeature(['customerAreaGet', 'lrma', 'priceList', 'customerAreaSave', 'extraCostSave', 'decorationSave', 'userGet', 'managementDashboard']));
        this.libraryService.getLibrary().then((lib) => {
            this.libraryChapters.set(lib);
        }, error => {

        });
    }

    drop(event: CdkDragDrop<string[]>, array) {
        if (this.editMode()) {
            moveItemInArray(array, event.previousIndex, event.currentIndex);
            array.forEach((item, index) => {
                item.order = index;
            });
            this.libraryService.changeOrder(array).then(result => {

            }, error => {

            });
        }
    }

    selectChapter(chapter?: Library[]) {
        this.selectedChapter.set(chapter);
        if (this.selectedChapter()) {
            this.cordovaService.setBackbuttonAction(() => {
                this.selectedChapter.set(null);
            });
        } else {
            this.cordovaService.setBackbuttonAction(() => {
                this.router.navigate(['/']);
            });
        }
    }

    logout() {
        this.confirmDialogService.confirm(
            'Uitloggen',
            `Wil je echt uitloggen?`,
            'Ja', 'Nee').then(() => {
            LocalStorage.logoutUser();
            this.firebase.unregister().then(() => {
                this.firebase.subscribe('alldevices');
            });
            this.router.navigate([`/login`]);
        }, () => {

        });
    }
}
